import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getCurrentPageByIndex, buildPagingArray } from './pagination-helper';
import { toAbsoluteUrlFromObject, toSearchString } from 'tradera-utils/url';
import PrevIcon from '@tradera/blueprint/theme/icons2/arrow-left.svg?jsx';
import NextIcon from '@tradera/blueprint/theme/icons2/arrow-right.svg?jsx';
import { withTranslator } from 'tradera-lang/translate';

class DiscoverPagination extends Component {
    static propTypes = {
        pagination: PropTypes.object,
        location: PropTypes.object,
        queryParams: PropTypes.object
    };

    getLinkValue = page => {
        const { location, queryParams } = this.props;
        if (page && location && queryParams) {
            const query = {
                ...queryParams,
                paging: page.paging,
                spage: page.pageIndex == 1 ? undefined : page.pageIndex
            };
            const url = {
                ...location,
                search: toSearchString(query)
            };
            return url;
        }
    };

    getNavLink = direction => {
        const {
            pagination: { pageLinks, pageIndex }
        } = this.props;

        const currentIndex = getCurrentPageByIndex(pageLinks, pageIndex);
        const linkIndex =
            direction === 'previous' ? currentIndex - 1 : currentIndex + 1;
        const hasLink = !!pageLinks[linkIndex];

        if (!hasLink) {
            return null;
        }

        return this.getLinkValue(pageLinks[linkIndex]);
    };

    renderPageLinks = (pageLinks, viewClass) => {
        return pageLinks.map((link, index) => {
            return (
                <li
                    className={`page-item ${viewClass} ${
                        link.active ? 'active' : ''
                    }${link.dotted ? 'disabled' : ''}`}
                    key={index}>
                    <Link
                        to={this.getLinkValue(link.pagination) || {}}
                        className="page-link">
                        {link.pagination ? link.pageIndex : '...'}
                    </Link>
                </li>
            );
        });
    };

    render() {
        const { pagination, t } = this.props;
        if (!pagination || (pagination && pagination.pageCount < 2)) {
            return null;
        }

        const { pageIndex, pageCount } = pagination;

        const desktopPagination = buildPagingArray(pagination);
        const mobilePagination = buildPagingArray(pagination, 1, 2);
        const prevLink = this.getNavLink('previous');
        const nextLink = this.getNavLink('next');

        const helmetLinks = [];

        if (prevLink) {
            helmetLinks.push({
                rel: 'prev',
                href: toAbsoluteUrlFromObject(prevLink)
            });
        }
        if (nextLink) {
            helmetLinks.push({
                rel: 'next',
                href: toAbsoluteUrlFromObject(nextLink)
            });
        }

        return (
            <div className="pb-3" data-search-results-pagination>
                <Helmet link={helmetLinks} />
                <nav aria-label="Search results pages">
                    <div className="pagination d-flex justify-content-center">
                        <div className="page-item">
                            <Link
                                to={prevLink ? prevLink : ''}
                                className={`btn btn-light text-primary mr-0 h-100 px-1 ${
                                    pageIndex !== 1 ? '' : 'disabled'
                                }`}
                                rel="prev">
                                <span className="d-lg-block d-none">
                                    {'<- ' +
                                        t('searchResults_paginationPrevious')}
                                </span>
                                <PrevIcon className="icon icon-sm icon-dark d-lg-none d-block h-100" />
                            </Link>
                        </div>
                        <div className="d-flex">
                            {this.renderPageLinks(
                                desktopPagination,
                                'd-none d-lg-block'
                            )}
                            {this.renderPageLinks(
                                mobilePagination,
                                'd-lg-none'
                            )}
                        </div>
                        <div className="page-item">
                            <Link
                                to={nextLink}
                                className={`btn btn-light text-primary ml-0 h-100 px-1 ${
                                    pageIndex !== pageCount ? '' : 'disabled'
                                }`}
                                rel="next">
                                <span className="d-lg-block d-none">
                                    {t('searchResults_paginationNext') + ' ->'}
                                </span>
                                <NextIcon className="icon icon-sm icon-dark d-lg-none d-block h-100" />
                            </Link>
                        </div>
                    </div>
                </nav>
            </div>
        );
    }
}

export const DiscoverPaginationWithRouter = withRouter(DiscoverPagination);
export default withTranslator(withRouter(DiscoverPagination));
